import type { MessageId } from "../i18n/messages"
import type { useI18n } from "../i18n/useI18n"

export type LibraryErrorCode =
  | "LIBRARY_SYNC_NO_WORKER"
  | "LIBRARY_SYNC_FAILED"
  | "LIBRARY_FETCH_FAILED"
  | "LIBRARY_DELETE_FAILED"

const LIBRARY_ERROR_MESSAGE_IDS: Record<LibraryErrorCode, MessageId> = {
  LIBRARY_DELETE_FAILED: "library.error.deleteFailed",
  LIBRARY_FETCH_FAILED: "library.error.fetchFailed",
  LIBRARY_SYNC_FAILED: "library.error.syncFailed",
  LIBRARY_SYNC_NO_WORKER: "library.error.syncUnavailable",
}

export class LibraryError extends Error {
  readonly code: LibraryErrorCode

  constructor(code: LibraryErrorCode, message?: string) {
    super(message ?? code)
    this.code = code
    this.name = "LibraryError"
  }
}

export function getLibraryErrorCode(error: unknown): LibraryErrorCode | null {
  return error instanceof LibraryError ? error.code : null
}

export function isLibrarySyncUnavailable(error: unknown): boolean {
  return getLibraryErrorCode(error) === "LIBRARY_SYNC_NO_WORKER"
}

export function getLibraryErrorLabel(
  t: ReturnType<typeof useI18n>["t"],
  error: unknown,
): string | null {
  const code = getLibraryErrorCode(error)
  if (code) return t(LIBRARY_ERROR_MESSAGE_IDS[code])
  return error instanceof Error ? error.message : null
}
